import React, { Component } from "react";

import {
  CCard,
  CCardBody,
  CRow,
  CCol,
  CLink,
  CButton,
  CFormGroup,
  CSpinner,
  CSwitch,
  CLabel,
  CInput,
  CToggler
} from "@coreui/react";
import PropTypes from "prop-types";
import ReactFlow, {
  removeElements,
  addEdge,
  MiniMap,
  Controls,
  Background
} from "react-flow-renderer";
import { RiAddFill } from "react-icons/ri";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select from "react-select";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import FileCreator from "../../../../components/Content/FileCreator";
import DuplicateTrailModal from "../../../../components/DuplicateTrailModal";
import ActivityEdge from "../../../../components/FlowEdges/ActivityEdge";
import ActivityNode from "../../../../components/FlowNodes/ActivityNode";
import InputNode from "../../../../components/FlowNodes/InputNode";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import {
  databaseToFlowTrail,
  flowToDatabaseTrail,
  styleTrail
} from "../../../../utils/trail";
import "./style.css";

class ActivityTrailEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      trail: null,
      duplicating: false,
      drag: true,
      elements: [],
      nodeTypes: {
        start: InputNode,
        activity: ActivityNode
      },
      edgeTypes: {
        default: ActivityEdge
      },
      saving: false,
      name: null,
      description: null,
      user_id: null,
      private: false,
      flowInstance: null,
      duplicateTrailModal: false,
      editingNameAndDescription: false,
      file: null,
      fileModal: false
      // contentList: null
    };

    this.div = React.createRef();
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    this.getTrail();
  }

  addElement = (e, id, direction = "down") => {
    const newElements = [
      ...this.state.elements,
      e,
      {
        id: `e${id}-${e.id}`,
        source: direction === "up" ? e.id : id,
        target: direction === "up" ? id : e.id,
        type: "default",
        data: {
          temporary: true,
          first: null,
          operator: null,
          second: null
        }
      }
    ];

    this.setState(state => ({
      elements: styleTrail(
        newElements,
        this.addElement,
        this.editElement,
        this.deleteElement,
        this.setDrag,
        true
      )
    }));
  };

  changeName = e => {
    this.setState({ name: e.target.value });
  };

  changeDescription = e => {
    this.setState({ description: e.target.value });
  };

  editElement = e => {
    const newElements = [...this.state.elements];

    newElements.find(item => item.id === e.id).data = e.data;

    this.setState(state => ({
      elements: styleTrail(
        newElements,
        this.addElement,
        this.editElement,
        this.deleteElement,
        this.setDrag,
        true
      )
    }));
  };

  deleteElement = e => {
    this.setState(state => ({
      elements: removeElements(
        [state.elements.find(item => item.id === e)],
        state.elements
      )
    }));
  };

  setDrag = drag => {
    this.setState({ drag });
  };

  getTrail() {
    axios
      .get(`${URL.api}activity/trail/show/${this.props.match.params.id}`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            const elements = databaseToFlowTrail(
              resp.data.data.trail_activities,
              resp.data.data.trail_edges
            );

            const styledElements = styleTrail(
              elements,
              this.addElement,
              this.editElement,
              this.deleteElement,
              this.setDrag,
              true
            );

            this.setState({
              trail: resp.data.data,
              name: resp.data.data.name,
              description: resp.data.data.description,
              private: resp.data.data.private,
              user_id: resp.data.data.user_id,
              is_partial_progression: resp.data.data.is_partial_progression,
              file: {
                list: {
                  name: resp.data.data.file?.split("/").reverse()[0]
                }
              },
              elements: styledElements,
              loading: false
            });
          } else {
            this.error("Não foi possível ver a trilha");

            this.setState({
              loading: false
            });
          }
        },
        error => {
          this.error("Não foi possível ver a trilha");

          this.setState({
            loading: false
          });
        }
      );
  }

  // getPossibleTrails() {
  //   axios
  //     .get(`${URL.api}activity/trail/possible`, {
  //       headers: { Authorization: `Bearer ${this.props.user.token}` }
  //     })
  //     .then(
  //       resp => {
  //         this.setState({
  //           possibleTrails: [
  //             { id: null, name: "Todos", users: [{ id: null, name: "Todos" }] },
  //             ...resp.data.data.map(room => ({
  //               ...room,
  //               users: [{ id: null, name: "Todos" }, ...room.users]
  //             }))
  //           ],
  //           room: {
  //             value: null,
  //             label: "Todos"
  //           }
  //         });
  //       },
  //       error => {
  //         this.error("Não foi possível listar as trilhas");
  //       }
  //     );
  // }

  onElementsRemove = elementsToRemove => {
    this.setState(state => ({
      elements: removeElements(elementsToRemove, state.elements)
    }));
  };

  onConnect = params => {
    this.setState(state => ({
      elements: styleTrail(
        addEdge(
          {
            ...params,
            type: "default",
            data: {
              temporary: true,
              first: null,
              operator: null,
              second: null
            }
          },
          state.elements
        ),
        this.addElement,
        this.editElement,
        this.deleteElement,
        this.setDrag,
        true
      )
    }));
  };

  saveTrail() {
    this.setState({ saving: true });

    const obj = {
      name: this.state.name,
      description: this.state.description,
      private: this.state.private,
      is_partial_progression: this.state.is_partial_progression,
      file: this.state.file.link,
      ...flowToDatabaseTrail(this.state.elements)
    };

    axios
      .post(
        `${URL.api}activity/trail/update/${this.props.match.params.id}`,
        obj,
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(
        resp => {
          if (resp.data.success) {
            this.setState(
              state => ({
                saving: false
              }),
              () => this.getTrail()
            );
          } else {
            toastr.error("Falha", "Não foi possível salvar a trilha");
            this.setState({ saving: false });
          }
        },
        () => {
          toastr.error("Falha", "Não foi possível salvar a trilha");
          this.setState({ saving: false });
        }
      );
  }

  deepDuplicate() {
    this.setState({ duplicating: true, duplicateTrailModal: false });

    axios
      .post(
        `${URL.api}activity/trail/deep_duplicate/${this.props.match.params.id}`,
        {},
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(
        resp => {
          if (resp.data.success) {
            this.props.history.push(`/trail/edit/${resp.data.data}`);
            this.setState({ duplicating: false, loading: true }, () => {
              this.componentDidMount();
            });
          } else {
            toastr.error("Falha", "Não foi possível duplicar a trilha");
            this.setState({ duplicating: false });
          }
        },
        () => {
          toastr.error("Falha", "Não foi possível duplicar a trilha");
          this.setState({ duplicating: false });
        }
      );
  }

  duplicate() {
    this.setState({ duplicating: true, duplicateTrailModal: false });

    axios
      .post(
        `${URL.api}activity/trail/duplicate/${this.props.match.params.id}`,
        {},
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(
        resp => {
          if (resp.data.success) {
            this.props.history.push(`/trail/edit/${resp.data.data}`);
            this.setState({ duplicating: false, loading: true }, () => {
              this.componentDidMount();
            });
          } else {
            toastr.error("Falha", "Não foi possível duplicar a trilha");
            this.setState({ duplicating: false });
          }
        },
        () => {
          toastr.error("Falha", "Não foi possível duplicar a trilha");
          this.setState({ duplicating: false });
        }
      );
  }

  onNodeDragStop() {
    this.setState(state => ({
      elements: state.flowInstance.getElements()
    }));
  }

  onLoad(flowInstance) {
    this.setState({ flowInstance });
  }

  handleFileChange = event => {
    // Atualize diretamente o estado 'file' com o arquivo selecionado
    this.setState({
      file: event.target.files[0]
    });
  };

  doneArchive = (uploads, name) => {
    let contentList = [];
    // this.state.contentList.forEach(list => {
    //   contentList.push(list);
    // });

    let obj = {
      type: 17,
      list: {
        id: uploads.split("/").reverse()[1].toLowerCase() === "repo" ? 0 : 1,
        name: name || uploads.split("/").reverse()[0]
      },
      link: uploads
    };

    if (this.state.editing) {
      contentList.splice(this.state.editIndex, 1, obj);
    } else {
      contentList.push(obj);
    }
    this.setState({
      // contentList,
      file: contentList[0]
    });
  };

  render() {
    const { elements } = this.state;

    let isAlagoas =
      this.props.general.active_roles.group_id === 49 ||
      this.props.general.active_roles.group_id === 86;

    return (
      <div
        className="w-100 h-100 flex-column bg-light flex-1 d-flex align-items-center justify-content-center position-relative"
        ref={this.div}
      >
        <DuplicateTrailModal
          id={this.props.match.params.id}
          show={this.state.duplicateTrailModal}
          onClose={() => this.setState({ duplicateTrailModal: false })}
          onDuplicate={() => this.duplicate()}
          onDeepDuplicate={() => this.deepDuplicate()}
        />
        <div
          className="d-flex w-100 bg-white px-5"
          style={{
            zIndex: 1000,
            borderBottom: "1px solid rgba(0, 0, 0, 0.125)"
          }}
        >
          <div className="flex-1 px-4 py-3">
            <Breadcrumb
              current={this.props.currentRoute}
              items={
                isAlagoas
                  ? [{ path: "/trail/bank", to: "/trail/bank" }]
                  : [{ path: "/trail/list", to: "/trail/list" }]
              }
            />
            <input
              placeholder="Nome"
              className={`h2 rounded text-primary mr-2 ${
                this.state.editingNameAndDescription
                  ? "border-primary mb-1 p-1"
                  : "p-0 border-0 mb-0 py-1 pr-1 pl-0"
              }`}
              value={this.state.name || "Carregando trilha..."}
              onChange={e => this.changeName(e)}
              disabled={this.state.loading}
              readOnly={!this.state.editingNameAndDescription}
            />
            <div
              className="text-muted"
              style={{ borderBottom: "1px solid white" }}
            >
              {!this.state.loading &&
                this.state.user_id !== this.props.user.user.id && (
                  <span className="">
                    <CLink to={`/profile/${this.state.trail.user.id}`}>
                      <i className="fa fa-user mr-2"></i>{" "}
                      {this.state.trail.user.name}
                    </CLink>
                    <span className="mx-2 text-light">|</span>
                  </span>
                )}
              {!this.state.loading ? (
                <input
                  placeholder="Descrição"
                  className={`h6 rounded text-muted mr-2 mb-0 ${
                    this.state.editingNameAndDescription
                      ? "border-primary p-1"
                      : "p-0 border-0 py-1 pr-1 pl-0"
                  }`}
                  value={this.state.description || "Carregando trilha..."}
                  onChange={e => this.changeDescription(e)}
                  disabled={this.state.loading}
                  readOnly={!this.state.editingNameAndDescription}
                />
              ) : (
                "Aguarde mais um pouco"
              )}
            </div>
          </div>
          <div className="d-flex">
            <>
              {this.state.fileModal && (
                <FileCreator
                  show
                  onClose={() =>
                    this.setState({ fileModal: false, editing: false })
                  }
                  doneArchive={(content, name) =>
                    this.doneArchive(content, name)
                  }
                />
              )}
              {isAlagoas && (
                <div className="d-flex flex-column justify-content-center mt-3 mx-4">
                  <CLabel className="text-muted mr-2 mb-0">
                    Progressão Parcial:
                  </CLabel>
                  <CSwitch
                    shape="pill"
                    variant="3d"
                    color="primary"
                    className="mt-3"
                    checked={this.state.is_partial_progression}
                    disabled={!this.state.editingNameAndDescription}
                    onChange={e => {
                      const { checked } = e.target;
                      this.setState({
                        is_partial_progression: checked
                      });
                    }}
                  />
                </div>
              )}

              <CButton
                color="primary"
                variant="ghost"
                block
                className="d-flex flex-column align-items-center justify-content-center rounded-0 m-0"
                onClick={() => this.setState({ fileModal: true })}
              >
                <i className="fa fa-paperclip mb-2"></i>
                <span>
                  {this.state.file
                    ? this.state.file.list.name
                    : "Adicionar Anexo"}
                </span>
              </CButton>
              <CButton
                color="primary"
                variant="ghost"
                block
                className="d-flex flex-column align-items-center justify-content-center rounded-0 m-0"
                title={
                  this.state.editingNameAndDescription ? "Salvar" : "Editar"
                }
                onClick={() => {
                  if (this.state.editingNameAndDescription) this.saveTrail();
                  this.setState(prevState => ({
                    editingNameAndDescription:
                      !prevState.editingNameAndDescription
                  }));
                }}
              >
                {this.state.editingNameAndDescription ? (
                  <i className="fa fa-save" />
                ) : (
                  <i className="fa fa-edit" />
                )}
                <span>
                  {this.state.editingNameAndDescription ? "Salvar" : "Editar"}
                </span>
              </CButton>
              <CButton
                color="primary"
                variant="ghost"
                block
                className="d-flex flex-column align-items-center justify-content-center rounded-0 m-0"
                onClick={() =>
                  this.props.history.push(
                    `/trail/allocate/${this.props.match.params.id}`
                  )
                }
              >
                <i className="fa fa-calendar mb-2"></i>
                <span>Alocar</span>
              </CButton>
              <CButton
                color="primary"
                variant="ghost"
                block
                className="d-flex flex-column align-items-center justify-content-center rounded-0 m-0"
                onClick={() => this.setState({ duplicateTrailModal: true })}
                disabled={this.state.duplicating}
              >
                <i className="fa fa-copy mb-2"></i>
                <span>
                  {this.state.duplicating ? "Copiando..." : "Fazer cópia"}
                </span>
              </CButton>
            </>
          </div>
        </div>
        {this.state.loading ? (
          <div className="d-flex flex-column align-items-center justify-content-center flex-1">
            <Loading />
          </div>
        ) : (
          <>
            {this.state.user_id === this.props.user.user.id && (
              <CButton
                color="primary"
                className="d-flex position-absolute rounded-circle align-items-center justify-content-center p-0 shadow-lg"
                style={{
                  zIndex: 1000,
                  bottom: "1.5rem",
                  right: "1.5rem",
                  width: "4rem",
                  height: "4rem"
                }}
                disabled={this.state.saving}
                onClick={() => this.saveTrail()}
              >
                {this.state.saving ? (
                  <CSpinner size="sm" color="white" />
                ) : (
                  <i
                    className="fa fa-save"
                    style={{
                      height: "auto",
                      fontSize: "1.5rem",
                      width: "auto"
                    }}
                  ></i>
                )}
              </CButton>
            )}
            <svg height="0" width="0">
              <defs>
                <marker
                  className="react-flow__arrowhead"
                  id="react-flow__arrowclosedactive"
                  markerWidth="12.5"
                  markerHeight="12.5"
                  viewBox="-10 -10 20 20"
                  orient="auto"
                  refX="0"
                  refY="0"
                >
                  <polyline
                    stroke="var(--primary)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                    fill="var(--primary)"
                    points="-5,-4 0,0 -5,4 -5,-4"
                  ></polyline>
                </marker>
              </defs>
            </svg>
            <ReactFlow
              style={{ flex: 1 }}
              elements={elements}
              onElementsRemove={this.onElementsRemove}
              onConnect={this.onConnect}
              onNodeDragStop={() => this.onNodeDragStop()}
              onLoad={e => this.onLoad(e)}
              snapToGrid
              snapGrid={[15, 15]}
              connectionLineType="smoothstep"
              minZoom={1}
              maxZoom={1}
              defaultZoom={1}
              defaultPosition={[
                ((this.div.current?.offsetWidth || 0) - 200) / 2,
                0
              ]}
              onlyRenderVisibleElements
              nodesDraggable={this.state.drag}
              zoomOnScroll={false}
              zoomOnPinch={false}
              panOnScroll
              panOnScrollMode="vertical"
              nodeTypes={this.state.nodeTypes}
              edgeTypes={this.state.edgeTypes}
              zoomOnDoubleClick={false}
              selectNodesOnDrag={false}
              translateExtent={[
                [-Infinity, 0],
                [Infinity, Infinity]
              ]}
              connectionLineStyle={{
                stroke: "var(--secondary)",
                strokeWidth: 2
              }}
            ></ReactFlow>
          </>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

ActivityTrailEdit.propTypes = {
  hideContainer: PropTypes.bool
};

ActivityTrailEdit.defaultProps = {
  hideContainer: true
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityTrailEdit);
